export default "__VITE_ASSET__zHJMYE7G__"